import React from 'react';

import { useDispatch } from 'react-redux';
import { changeCustomFieldFilters } from '../store/actions/query';
import { delayRetrieveRecords } from '../store/actions/search';

import Tag from 'components/tags/tag';
import { formatDate } from 'helpers/formatters/date_time_formats';

import type { CustomFieldSchema } from 'bundles/crm/types';
import type { Filter } from './types';

interface Props {
  filter: Filter;
  schema: CustomFieldSchema;
}

export default function CompCustomFieldFilterTag({ filter, schema }: Props) {
  const dispatch = useDispatch();

  let label = filter;
  if (typeof filter === 'object') {
    let labelParts: (number | string)[] = [];

    if (filter.min != null && filter.min !== '') {
      labelParts.push(filter.min);
    }

    if (filter.max != null && filter.max !== '') {
      labelParts.push(filter.max);
    }

    if (schema.valueType === 'date') {
      labelParts = labelParts.map(part => formatDate(part));
    }

    label = labelParts.join(' - ');
  }

  function removeFilter() {
    dispatch(changeCustomFieldFilters({ [schema.slug]: undefined }));
    // TODO: No reason for this to be debounced, but something is wrong with the comp store and
    //       using a non-debounced action acted incorrectly
    dispatch(delayRetrieveRecords());
  }

  return (
    <Tag removable onRemove={removeFilter}>
      {schema.label}: {label}
    </Tag>
  );
}
